module.exports = __webpack_public_path__ + "static/media/pacific.171c5802.png";